export type AppTheme = 'light' | 'dark'

const THEME_KEY = 'app-theme'

export function setTheme(theme: AppTheme) {
  document.documentElement.dataset.theme = theme
  localStorage.setItem(THEME_KEY, theme)
}

export function getTheme(): AppTheme {
  const savedTheme = localStorage.getItem(THEME_KEY) as AppTheme | null

  if (savedTheme === 'light' || savedTheme === 'dark') {
    return savedTheme
  }

  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches

  return systemDark ? 'dark' : 'light'
}

export function toggleTheme() {
  const currentTheme = getTheme()
  setTheme(currentTheme === 'light' ? 'dark' : 'light')
}

export function initTheme() {
  setTheme(getTheme())
}